import { DateService } from '@qsp-ui-library/classes/date-service.class';

/**
 * @returns {DateService} date service
 */
export function dateFactory(): DateService {
  return new DateService();
}
